import apiClient from "../../axios/apiClient";

export const getTripReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc",formData) =>
  async (dispatch) => {
    try {
        const userId = formData.userId ? formData.userId : 0;
        const trip_start = formData.trip_start ? formData.trip_start : 0;
        const trip_end = formData.trip_end ? formData.trip_end : 0;
      dispatch({ type: "GET_TRIP_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Trip-Report?`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            userId: userId,
            trip_start: trip_start,
            trip_end: trip_end,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_TRIP_REPORT_FULFILLED",
        payload: response?.data?.data,
        count: response?.data?.count,
        permissions: response?.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_TRIP_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };

  export const getTripReportApprovalList =
  (token, limit = 10, page = 1, search = "", sort = "desc",formData) =>
  async (dispatch) => {
    try {
        const userId = formData.userId ? formData.userId : 0;
        const trip_start = formData.trip_start ? formData.trip_start : 0;
        const trip_end = formData.trip_end ? formData.trip_end : 0;
      dispatch({ type: "GET_TRIP_REPORT_APPROVAL_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Trip-Approval-Report?`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            userId: userId,
            trip_start: trip_start,
            trip_end: trip_end,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_TRIP_REPORT_APPROVAL_FULFILLED",
        payload: response?.data?.data,
        count: response?.data?.count,
        permissions: response?.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_TRIP_REPORT_APPROVAL_REJECTED",
        payload: error.response,
      });
    }
  };

export const approveTripReport = (token, payload) => async (dispatch) => {
  try {
    dispatch({ type: "APPROVE_TRIP_REPORT_PENDING" });
    const response = await apiClient.post(
      `/api/admin/v1/Trip-Approval`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    dispatch({ type: "APPROVE_TRIP_REPORT_FULFILLED", payload: response.data });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "APPROVE_TRIP_REPORT_REJECTED",
      payload: error.response,
    });
  }
};

export const getTripApprovalList =
  (token, limit = 10, page = 1, search = "", sort = "desc", formData) =>
  async (dispatch) => {
    try {
      const userId = formData?.userId ? formData.userId : 0;
      const trip_start = formData?.trip_start ? formData.trip_start : 0;
      const trip_end = formData?.trip_end ? formData.trip_end : 0;
      dispatch({ type: "GET_TRIP_APPROVAL_PENDING" });

      const response = await apiClient.get(`/api/admin/v1/Trip-Approval-Report`, 
        {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          limit: limit,
          page: page,
          search: search,
          sort: sort,
          userId: userId,
          trip_start: trip_start,
          trip_end: trip_end,
        },
      });
      dispatch({
        type: "GET_TRIP_APPROVAL_FULFILLED",
        payload: response?.data?.data,
        count: response?.data?.count,
        permissions: response?.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_TRIP_APPROVAL_REJECTED",
        payload: error.response,
      });
    }
  };

export const getTripApprovalReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", formData) =>
  async (dispatch) => {
    try {
      const userId = formData?.userId ? formData.userId : 0;
      const trip_start = formData?.trip_start ? formData.trip_start : 0;
      const trip_end = formData?.trip_end ? formData.trip_end : 0;
      dispatch({ type: "GET_TRIP_APPROVAL_REPORT_PENDING" });

      const response = await apiClient.get(`/api/admin/v1/Trip-Approval-Report?`, {
        params: {
          limit: limit,
          page: page,
          search: search,
          sort: sort,
          userId: userId,
          trip_start: trip_start,
          trip_end: trip_end,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch({
        type: "GET_TRIP_APPROVAL_REPORT_FULFILLED",
        payload: response?.data?.data,
        count: response?.data?.count,
        permissions: response?.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_TRIP_APPROVAL_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };